//I Would Highly Recommend You To Customize The Theme According To Your Taste.
export const globalStyles = {
  "--grad": "linear-gradient(315deg,#2A5470, #4C4177)", // Use gradients only
  // "--grad": "linear-gradient(315deg, #48a9fe 0%, #734ae8 80%)", // Use gradients only
  // "--grad": "linear-gradient(315deg, #282B32 0%, #1C1F26 74%)",
  "--txtcolor": "#272341",
  "--p_color": "#00cdac",
  "--s_color": "#fff",
};

// Navigation Bar Name
export const navbar_name = "Vipin";

// Main Page
export const main = {
  name: "Vipin Awadhiya",
  doamin: "A MERN Stack Web Developer",
  resume:
    "https://drive.google.com/file/d/1BBjYnC2S2zn0euMe9fyzyEwjNRfRKkze/view?usp=sharing",
};

// AboutMe
export const aboutme = {
  imgLink:
    "https://avatars.githubusercontent.com/u/95866868?v=4?raw=true",
  p1: "Hey, My name is Vipin Awadhiya. I have completed my Bachelor of Engineering in Civil Branch from Sagar institute of research & technology , Bhopal(M.P.).",
  p2: " A very observant and result-driven web developer with a specialization in the frontend,  dedicated to building and optimizing user-focused websites for customers. Looking forward to working in an organization where my curiosity and learning abilities can be satisfied..",
  p3: "Apart from coding I also like to do sketching & painting , Playing Cricket 🏏.",
};

// Skills
export const whatido = {
  title: "Full Stack Development",

  details: [
    "Building responsive website using HTML,CSS,JS,React",
    "Creating backend application in Node, ExpressJS",
    "Building Simple RESTful CRUD APIs",
    "Knowledge of MongoDB Database",
  ],
  logos: [
    {
      name: "HTML5",
      iconifyClassName: "vscode-icons:file-type-html", // PS : Use iconify class name
      id: "1",
    },
    {
      name: "CSS",
      iconifyClassName: "vscode-icons:file-type-css",
      id: "2",
    },
    {
      name: "JavaScript",
      iconifyClassName: "logos:javascript",
      id: "3",
    },
    {
      name: "ReactJS",
      iconifyClassName: "vscode-icons:file-type-reactjs",
      id: "4",
    },
    {
      name: "Redux",
      iconifyClassName: "logos:redux",
      id: "5",
    },
    {
      name: "NodeJS",
      iconifyClassName: "logos:nodejs",
      id: "6",
    },
    {
      name: "ExpressJS",
      iconifyClassName: "logos:express",
      id: "7",
    },
    {
      name: "MongoDB",
      iconifyClassName: "logos:mongodb",
      id: "8",
    },
    {
      name: "Postman",
      iconifyClassName: "logos:postman-icon",
      id: "9",
    },
    {
      name: "npm",
      iconifyClassName: "logos:npm-icon",
      id: "10",
    },
    {
      name: "GIT",
      iconifyClassName: "logos:git",
      id: "11",
    },
    {
      name: "Netlify",
      iconifyClassName: "vscode-icons:file-type-netlify",
      id: "15",
    },
    
  ],
};

// Project Details
export const details = [
  {
    id: 1,
    title: "KIMAYE CLONE",
    desc: `Kimaye is growers of India's finest fruits, you can order fruits online through their website.`,
    feature: `Sign-in/Sign-up, Responsiveness in landing page, Manual display carousel, Add to cart & Check out.`,
    tech: `Tech Stack:HTML | CSS | JavaScript`,
    img: "https://user-images.githubusercontent.com/95927895/158878550-2d6259f7-7eaf-4609-a5bf-9ba5c514943e.png",

    link: "https://kimaye.netlify.app/",
    github: "https://github.com/Vipin115/Kimaye-clone.git",
  },
  {
    id: 2,
    title: "Shopclues Clone",
    desc: `Shopclues is one of the most famous e-commerce sites in india. Developed a look a like of it.`,
    feature: `Sign-in/Sign-up, User Authentication, Sort and Filter Functionality, Added API for Mobiles Products, Added API for user Page, Add to cart & Paytm payment gateway.`,
    tech: `Tech Stack: JavaScript | Node JS | Express JS | MongoDB | HTML | CSS `,
    img: "https://user-images.githubusercontent.com/95927895/158878832-a8681047-98e3-4bae-9498-936a3c04a932.png",
    github: "https://github.com/Vipin115/shopclues.com-backend.git",
    link: "https://shopclues-backend.netlify.app/",
  },
  {
    id: 3,
    title: "SonyLiv clone",
    desc: `SonyLiv is an indian over-the-top freemium streaming platform.`,
    feature: `Sign-in/Sign-up, User Authentication, Carousels for exploring content.`,
    tech: `Tech Stack: React | JavaScript | Node JS | Express JS | MongoDB | HTML | CSS `,
    img: "https://camo.githubusercontent.com/0f8e34dfdb5942765e78430f3c694544cb088480e60a1ad7c900c0f9191ac48a/68747470733a2f2f692e696d6775722e636f6d2f4a56637733424a2e706e67",
    github: "https://github.com/Vipin115/SonyLiv",
    link: "https://sonylivv.netlify.app/",
  },
];

// Social Media Links
export const links = [
  "https://www.instagram.com/vipin_avadhiya115/",
  "https://www.linkedin.com/in/vipin-awadhiya-8868b613b/",
  "https://api.whatsapp.com/send/?phone=7898677597&text&app_absent=0",
  "mailto:vipinawd115@gmail.com",
  "https://github.com/Vipin115",
  "https://twitter.com/vipinawadhiya3",
];
